<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">expired</li>
    </ol>
  </nav>
  <div class="container">
    <div class="top--section">
      <h1>有効期限が切れています</h1>
      <p>
				もう一度メンバー登録し直してください<br />
			</p>
			<router-link :to="{ path: '/top'}" class="btn btn-primary">トップページへ戻る</router-link>
    </div>
  </div>
</template>
